"use client";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { Container, Typography } from "@mui/material";

export default function NotFound() {
  const pathname = usePathname();

  return (
    <Container
      maxWidth="expanded"
      sx={{
        gap: 3,
        height: "100dvh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center"
      }}
    >
      <Typography
        component="h1"
        variant="displayLg"
        fontSize={80}
        color="var(--tertiary-color)"
      >
        404
      </Typography>
      <Typography
        align="center"
        component="p"
        variant="displayMd"
        sx={{ textWrap: "balance" }}
      >
        Sorry, the page <strong>{pathname}</strong> could not be found
      </Typography>
      <Link href="/">Back to homepage</Link>
    </Container>
  );
}
